module.exports = __webpack_public_path__ + "img/4.4a236efb.jpg";